<template>
    <div class="flex items-center justify-between mt-2 mb-4">
        <button
            :class="disabledPrev ? ['bg-gray-400', 'cursor-not-allowed'] : ['hover:bg-vida-gray']"
            class="p-4 mr-2 text-white transition duration-300 ease-in-out bg-black w-36 "
            @click="formStepPrev()"
            :disabled="disabledPrev"
        >
            <i 
                :class="disabledPrev ? ['fal', 'fa-times'] : ['far', 'fa-arrow-left']"
            >
            </i>
        </button>
        <button
            :class="disabledNext ? ['bg-gray-400', 'cursor-not-allowed'] : ['hover:bg-vida-gray']"
            class="p-4 ml-2 text-white transition duration-300 ease-in-out bg-black w-36"
            @click="formStepNext()"
            :disabled="disabledNext"
            v-if="!disabledNext"
        >
            <i 
                :class="disabledNext ? ['fal', 'fa-times'] : ['far', 'fa-arrow-right']"
            >
            </i>
        </button>
        <button
            class="p-4 ml-2 text-white transition duration-300 ease-in-out bg-black w-36"
            @click="showModal(); snapShotBlob()"
            v-if="disabledNext"
        >
            <i class="mr-1 far fa-file-download"></i> Offerte
        </button>
        <ContactModal
            v-show="isModalVisible"
            @close="closeModal"
        >
        </ContactModal>
    </div>
</template>

<script>
    import ContactModal from '@/components/steps/ContactModal.vue'

    import { mapMutations } from 'vuex'

    export default {
        name: "FormButtons",
        components: {
            ContactModal
        },
        data() {
            return {
                isModalVisible: false,
            }
        },
        methods: {
            ...mapMutations([
                'setSnapShot'
            ]),
            formStepNext() {
                this.$store.commit('formStepNext')
            },
            formStepPrev() {
                this.$store.commit('formStepPrev')
            },
            showModal() {
                this.isModalVisible = true;
            },
            closeModal() {
                this.isModalVisible = false;
            },
            snapShotBlob() {
                this.setSnapShot(true)
            }
        },
        computed: {
            formStep() {
                return this.$store.state.formStep;
            },
            disabledPrev() {
                let disabledPrev = ''
                if(this.formStep === 1) {
                    disabledPrev = true
                } else {
                    disabledPrev = false
                }
                return disabledPrev
            },
            disabledNext() {
                let disabledNext = ''
                if(this.formStep === 6) {
                    disabledNext = true
                } else {
                    disabledNext = false
                }
                return disabledNext
            }
        }
    }
</script>

<style>

</style>